// Global packages and components
import { Heading, ProductCard, Slider } from '~/components'

// Types
import type { ProductSearchItem } from '~/types'

interface Props {
  products: ProductSearchItem[]
  title?: string
}

/*
  Sibling products from the same category, as a carousel matching Recently
  viewed. Rendered from loader data, and the slider puts every slide in the
  HTML, so the product links stay reachable without running JavaScript. Schema
  is handled by the route's JSON-LD, so no microdata here.
*/
const RelatedProducts = ({ products, title = 'Related products' }: Props) => {
  if (!products || products.length === 0) return null

  return (
    <section className="container mb-16">
      <Heading
        tag="h2"
        size="h4"
        className="mb-10 text-center"
      >
        {title}
      </Heading>
      <Slider
        className="slider-products w-full"
        arrowsInline
        options={{
          arrows: true,
          pagination: false,
          perMove: 1,
          autoWidth: true,
          gap: '1.5rem',
        }}
      >
        {products.map((product, i) => (
          <div
            key={product.url?.stockCode ?? i}
            className="h-full w-80"
          >
            <ProductCard {...product} />
          </div>
        ))}
      </Slider>
    </section>
  )
}

export default RelatedProducts
